import type { IconData } from '@stacksjs/iconify-core'

export const video: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m461 132l-101 39.277V72H16v368h344V332.723L461 372h35V132Zm3 206.833l-136-52.89V408H48V104h280v114.057l136-52.89Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default video
